import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { AccTeamVenture } from '@interfaces';
import { AccTeamDialogDataService } from '../../acc-team-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, dialog: DialogService, dialogDataService: AccTeamDialogDataService): GridSetup<AccTeamVenture> {

	return {
		rowName: { singular: 'Venture', plural: 'Ventures' },
		getRowKey: row => '' + row.accVentureId,
		stateKey: 'acc-team-ventures-grid',
		actions: getActions(dialog, dialogDataService),
		buttons: getButtons(dialog, dialogDataService),
		columns: getColumns(util),
	}
}
